import type Admin from "@types_def/models/admin.types";
import type Client from "@types_def/models/client.types";

export function isAdmin(user: Admin | Client): user is Admin {
  return (<Admin>user).firstName !== undefined;
}
